import { Component, OnInit } from '@angular/core';
import { ECRService } from '../service/ecr.service';
import { ExcelService } from '../service/excel.service';

@Component({
  selector: 'app-ecrhradmin',
  templateUrl: './ecrhradmin.component.html',
  styleUrls: ['./ecrhradmin.component.css']
})
export class EcrhradminComponent implements OnInit {
  EmployeeDetails: any[] = [];
  DepartmentList: any[] = [];
  SBUList: any;
  BranchList: any;
  EmployeeList: any[] = [];
  HRECRList: any;
  SBU: string = "";
  Department: string = "";
  ECRMonth: number = new Date().getMonth() + 1;
  ECRYear: string = "2021";
  TempHRECRList: any;
  EmployeeId: string = '';

  constructor(private _ecrService: ECRService, private excelService: ExcelService) { }

  ngOnInit() {
    this.getHRECR();
    this.getSummary();
  }

  onSBUChange(): void {
    this.Department = '';
    this.EmployeeId = '';
    this.updateDepartmentList();
    this.updateEmployeeList();
    this.getHRECR();
  }

  onDepartmentChange(): void {
    this.EmployeeId = '';
    this.updateEmployeeList();
    this.getHRECR();
  }

  onEmployeeChange(): void {
    this.getHRECR();
  }

  onMonthChange(): void {
    this.getHRECR();
  }

  onYearChange(): void {
    this.getHRECR();
  }

  private updateDepartmentList(): void {
    let source = this.EmployeeDetails || [];
    if (this.SBU) {
      source = source.filter(x => x.SBU === this.SBU);
    }
    this.DepartmentList = source
      .map(item => item.Department)
      .filter((value, index, self) => value && self.indexOf(value) === index)
      .sort((a, b) => (a < b ? -1 : 1));
  }

  private updateEmployeeList(): void {
    let source = this.EmployeeDetails || [];
    if (this.SBU) {
      source = source.filter(x => x.SBU === this.SBU);
    }
    if (this.Department) {
      source = source.filter(x => x.Department === this.Department);
    }

    const seen: any = {};
    this.EmployeeList = source
      .map(item => ({ Name: item.MemberName, TMCNo: String(item.UserID) }))
      .filter(item => {
        if (!item.TMCNo || seen[item.TMCNo]) {
          return false;
        }
        seen[item.TMCNo] = true;
        return true;
      })
      .sort((a, b) => (a.Name < b.Name ? -1 : 1));
  }
  exportAsXLSX(): void {
    if ((confirm('Do you want to download excel file'))) {
      this.excelService.exportAsExcelFile(this.HRECRList, 'ECR_Data');
    }

  }
  title = 'exportExcelInAngular';
  dataOfFootballers: any = [{
    playerName: 'Cristiano Ronaldo',
    playerCountry: 'Pourtgal',
    playerClub: 'Juventus'
  },
  {
    playerName: 'Lionel Messi',
    playerCountry: 'Argentina',
    playerClub: 'Barcelona'
  },
  {
    playerName: 'Neymar Junior',
    playerCountry: 'Brazil',
    playerClub: 'PSG'
  },
  {
    playerName: 'Tonni Kroos',
    playerCountry: 'Germany',
    playerClub: 'Real Madrid'
  },
  {
    playerName: 'Paul Pogba',
    playerCountry: 'France',
    playerClub: 'Manchester United'
  }];
  getHRECR() {
    const employeeId = this.EmployeeId || '';
    this._ecrService.GetHRECR(this.SBU, this.Department, this.ECRMonth, this.ECRYear, employeeId).subscribe(
      data => {
        //debugger;
        this.TempHRECRList = data.Data;
        this.HRECRList = data.Data;
        console.log(data);
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }
  DownloadExcel() {
    alert('hello');
  }

  getSummary() {
    this._ecrService.GetMasters().subscribe(
      data => {
        this.EmployeeDetails = data.Data;
        this.SBUList = this.EmployeeDetails.map(item => item.SBU)
          .filter((value, index, self) => self.indexOf(value) === index);
        this.SBUList.sort((a, b) => (a < b ? -1 : 1));
        this.BranchList =
          this.EmployeeDetails.map(item => item.Branch)
            .filter((value, index, self) => self.indexOf(value) === index);
        this.BranchList.sort((a, b) => (a < b ? -1 : 1));
        this.updateDepartmentList();
        this.updateEmployeeList();
        console.log(data);
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }
}
